import { SCAN_TYPE } from '@/features/Scan/constants';

export const getViewTypeFromUserPreference = () => {
	const userPreference = JSON.parse(localStorage.getItem('userInfo'));
	const viewType = userPreference?.systemPreference?.SCAN_VIEW_TYPE || 'LIST_VIEW';
	return viewType;
};

export const getViewTypeClass = (viewType) => {
	const classes = {
		LIST_VIEW: 'scan-list-table',
		LARGE_VIEW: 'large-view',
		NARROW_VIEW: 'narrow-view'
	};
	return classes[viewType] || '';
};

export const getFormattedQRcode = (value) => {
	const sampleIdFirstPattern = /^\d+$/;
	const sampleIdSecondPattern = /^[A-Za-z0-9-]+;(\d+)$/;
	const sampleIdThirdPattern = /.*;([^;]+)$/;
	const locationIdPattern = /^[Ll][A-Za-z]*#\d+$/;

	if (sampleIdFirstPattern.test(value)) {
		return { sampleId: value.trim() };
	} else if (sampleIdSecondPattern.test(value)) {
		return { sampleId: value.split(';')[1].trim() };
	} else if (sampleIdThirdPattern.test(value)) {
		const matches = value.match(sampleIdThirdPattern);
		return { sampleId: matches[1].trim() };
	} else if (locationIdPattern.test(value)) {
		return { locationId: value.trim() };
	}

	return {};
};

export const isMediaDevicesSupported = () => {
	const isMediaDevicesSupported = typeof navigator !== 'undefined' && !!navigator.mediaDevices;

	return isMediaDevicesSupported;
};

export const getErrorMessage = (errors = []) => {
	return errors
		.filter(Boolean)
		.map((error) => {
			// Handle different error structures
			if (typeof error === 'string') return error;
			if (error.data?.error) return error.data.error;
			if (error.message) return error.message;
			if (error.data?.message) return error.data.message;

			// If error has status code, include it in generic message
			if (error.status) {
				return `Request failed with status ${error.status}`;
			}

			return 'An unexpected error occurred';
		})
		.filter((message, index, array) => array.indexOf(message) === index);
};

export const getLoadingState = (loadingStates = []) => {
	return loadingStates.some((state) => state === true);
};

export const filterOutNotFoundItems = (scannedItems) => {
	return scannedItems.filter((item) => item.isFound);
};

export const renderLocationDetails = (response, field) => {
	const value = response?.[field]?.text;
	return value ? `, ${value}` : '';
};

export const getScanType = (qrCode, isCycleStart, isLocationScanned) => {
	if (qrCode.sampleId) {
		return SCAN_TYPE.NEW_SAMPLE_SCAN;
	}
	if (qrCode.locationId && isCycleStart && !isLocationScanned) {
		return SCAN_TYPE.UPDATE_LOCATION;
	}
	if (qrCode.locationId && !isCycleStart && !isLocationScanned) {
		return SCAN_TYPE.FETCH_LOCATION_SAMPLES;
	}
	if (qrCode.locationId && isCycleStart && isLocationScanned) {
		return SCAN_TYPE.REPLACE_LOCATION;
	}
	return SCAN_TYPE.UNKNOWN;
};
